export class IntacctIntegration {
  intacctId: string = null;
}
